import { render, staticRenderFns } from "./drag_horizontal.vue?vue&type=template&id=2c716397&"
import script from "./drag_horizontal.vue?vue&type=script&lang=js&"
export * from "./drag_horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports